import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Montserrat:300,600');
  
  *, *::before, *::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  body {
    margin: 0;
    padding: 0;
    font-family:  sans-serif;
    color:#3f454d
  }
  .invalid{
    bottom: 0;
    color: #fa3e54;
    font-size: 10px;
  }
.nav-tabs{
  .nav-item{
    color: #73a52e;
    font-weight: 400;
    letter-spacing:3px;
    padding: 10px 40px;
  }
}
table{
  th, td{
    vertical-align:middle !important;
    text-align:center;
    padding:2px !important;
  }
}

  .dillak {
    font-weight:bold;
    color: #73a52e;
   }
  .surówka {
    font-weight:bold;
    color: #ffbd40;
   }
   .podkład {
     font-weight:bold;
    color: #f5f5f5;
    text-shadow: 1px 1px 3px rgb(75, 75, 75);
   }
   .szlifiernia {
     font-weight:bold;
    color: #33cec3
   }
   .lakiernia {
     font-weight:bold;
    color: #a4cfff
   }
   .polernia {
     font-weight:bold;
    color: #fa3e54
   }
   .pakowanie {
     font-weight:bold;
    color: #85eb6a
   }
   .zakończone {
     font-weight:bold;
    color: #e165b9
   }
   .transport {
     font-weight:bold;
    color: gray
   }
   option{
    &.dillak {
    font-weight:bold;
    background-color: #73a52e;
   }
    &.surówka {
    font-weight:bold;
    background-color: #ffbd40;
   }
   &.podkład {
     font-weight:bold;
    background-color: #f5f5f5;
   }
   &.szlifiernia {
     font-weight:bold;
    background-color: #33cec3
   }
   &.lakiernia {
     font-weight:bold;
    background-color: #a4cfff
   }
   &.polernia {
     font-weight:bold;
    background-color: #fa3e54
   }
   &.pakowanie {
     font-weight:bold;
    background-color: #85eb6a
   }
   &.zakończone {
     font-weight:bold;
    background-color: #e165b9
   }
   &.transport {
     font-weight:bold;
     background-color: gray
   }
   }

   .custom-react-datepicker{
    border-radius: 5px;
    border: 1px solid #73a52e;
    height: 36px;
    margin: 0 5px;
   }

`;

export default GlobalStyle;
